import React from 'react';
import dayjs from 'dayjs';
import { Button, Table } from 'react-bootstrap';
import { FaTimesCircle } from 'react-icons/fa';
import { EmployeeConfigMaster } from "../../../models/config/EmployeeConfigMaster";
import {useCompanyMaster} from "../../../queries";

export type EmployeeConfigMasterTableProps = {
    employeeConfigs?: EmployeeConfigMaster[];
    isPending?: boolean;
    onDelete?: (employeeConfigs: EmployeeConfigMaster) => void;
};

export const EmployeeConfigMasterTable = (
    props: EmployeeConfigMasterTableProps
) => {
    const { isPending, employeeConfigs, onDelete } = props;
    
    const { data: companyMaster } = useCompanyMaster()
    const companyMasterMap = new Map(companyMaster?.map(company => [company.sid, company]));
    
    return (
        <div className="tw-overflow-auto">
            <Table
                className="table-bordered align-middle"
                size="sm"
            >
                <thead>
                    <tr className="table-active thead-light tw-w-full tw-text-center">
                        <th />
                        <th className="nowrap">Company</th>
                        <th className="nowrap">Role Access</th>
                        <th className="nowrap">Employee ID</th>
                        <th className="nowrap">Create By</th>
                        <th className="nowrap">Create On</th>
                    </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={7}>
                                <div className="tw-flex tw-items-center tw-justify-center">
                                    <div className="spinner-border text-primary tw-my-2" />
                                </div>
                            </td>
                        </tr>
                    ) : (
                        employeeConfigs?.map((employeeConfig, index) => {
                            const formattedCreatedOn = employeeConfig.created_on
                                ? dayjs(
                                    employeeConfig.created_on,
                                    'YYYYMMDDHHmmss'
                                ).format('DD/MM/YYYY HH:mm น.')
                                : undefined;

                            return (
                                <tr key={employeeConfig.id + index}>
                                    <td className="tw-whitespace-nowrap align-middle">
                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            className="tw-ml-1"
                                            onClick={() => onDelete?.(employeeConfig)}
                                        >
                                            <FaTimesCircle />
                                        </Button>
                                    </td>
                                    <td className="tw-whitespace-nowrap align-middle text-center">
                                        {employeeConfig.sid !== '*'
                                            ? companyMasterMap.get(employeeConfig.sid)?.company_name
                                            : "*"}
                                    </td>
                                    <td className="align-middle">
                                        {employeeConfig.role_access}
                                    </td>
                                    <td className="align-middle">
                                        {employeeConfig.id}
                                    </td>
                                    <td className="align-middle">
                                        {formattedCreatedOn}
                                    </td>
                                    <td className="align-middle">
                                        {employeeConfig.created_by}
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};
